import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useBreakpoint } from '@app/hooks';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import { AlloyButton, AlloyIcon } from 'cat-ecommerce-alloy';
import CoreDepositPopup from '@app/components/common/CoreDepositPopup';
import { numOfDaggers } from '@app/components/pages/checkout/shopping-cart/QuickOrder/utils';

const UnitPriceTableCell = ({
  unitPrice,
  showCoreCharges,
  coreCharges,
  currency
}) => {
  const [t] = useTranslation();
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);

  const gstUnitPriceFlag = useSelector(
    s => s.checkout.currentAddToCartModifications.isGstAvailable
  );
  const gstIncludesTax = useSelector(
    s => s.checkout.currentAddToCartModifications.isGstIncludesTax
  );
  const isQuantityMergeEnabled = useSelector(
    s => s.common?.isQuantityMergeEnabled
  );

  const popperOptions = {
    placement: 'left',
    modifiers: [
      {
        name: 'flip',
        options: {
          rootBoundary: 'document',
          fallbackPlacements: ['bottom']
        }
      }
    ]
  };
  const initiator = (
    <AlloyButton
      buttonType="link"
      className={cx('p-0 text-nowrap text-xs d-inline-flex align-items-center')}
    >
      <AlloyIcon
        width={16}
        height={16}
        icon="icon-info"
        className="u-fill--DarkGray me-1 d-print-none"
      />
      <div>{t('CAT_CORE_DEPOSIT_LABEL')}</div>
    </AlloyButton>
  );
  return (
    <>
      {unitPrice && (
        <div
          className={`d-flex ${
            isLG ? 'justify-content-end' : 'justify-content-start'
          }`}
        >
          <div className="fw-bold">{unitPrice}</div>
          {!isLG && <div className="ms-1">{`(${currency})`}</div>}
        </div>
      )}
      <>
        {!isLG && typeof gstIncludesTax === 'boolean' && gstUnitPriceFlag && (
          <p className="u-fs--12 u-color--DarkGray text-capitalize mb-0">
            {gstIncludesTax ? (
              <>
                {t('CAT_INCLUDES_GST')}
                {numOfDaggers(isQuantityMergeEnabled)}
              </>
            ) : (
              <>
                {t('GST_EXCLUDES')}
                {numOfDaggers(isQuantityMergeEnabled)}
              </>
            )}
          </p>
        )}
      </>
      {showCoreCharges && (
        <div
          className={`d-flex u-fs--12 ${
            isLG ? 'flex-column align-items-end' : 'mt-1'
          }`}
        >
          <CoreDepositPopup
            initiator={initiator}
            popperOptions={popperOptions}
          />
          <div className="ms-1 fw-normal">{coreCharges}</div>
        </div>
      )}
    </>
  );
};
UnitPriceTableCell.propTypes = {
  unitPrice: PropTypes.string,
  showCoreCharges: PropTypes.bool,
  coreCharges: PropTypes.string,
  currency: PropTypes.string
};

export default UnitPriceTableCell;
